<template>
  <div>
    <div class="flex justify-between items-center">
      <h1 class="font-bold text-2xl text-primary-500">
        {{ template?.name || 'Cargando...' }}
      </h1>
      <div class="flex gap-2">
        <router-link
          v-if="template"
          :to="{ name: 'dietTemplatesEdit', params: { id: template.id } }"
          class="secondary-button"
        >
          Editar
        </router-link>
        <router-link
          :to="{ name: 'dietTemplatesIndex' }"
          class="secondary-button"
        >
          Volver
        </router-link>
      </div>
    </div>

    <div v-if="loading" class="mt-8 flex justify-center">
      <loader-icon class="w-8 h-8 animate-spin" />
    </div>

    <div v-else-if="template" class="mt-8">
      <div class="card">
        <h2 class="font-semibold text-lg mb-4">Información General</h2>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p class="text-sm text-gray-600">Tipo de plantilla</p>
            <p class="font-medium">{{ getTemplateTypeLabel(template.template_type) }}</p>
          </div>
          
          <div>
            <p class="text-sm text-gray-600">Estado</p>
            <p class="font-medium">
              <span
                class="px-2 py-1 text-xs rounded"
                :class="template.is_active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'"
              >
                {{ template.is_active ? 'Activa' : 'Inactiva' }}
              </span>
            </p>
          </div>
          
          
          <div v-if="template.duration_days">
            <p class="text-sm text-gray-600">Duración</p>
            <p class="font-medium">{{ template.duration_days }} días</p>
          </div>
        </div>
        
        <div v-if="template.description" class="mt-4">
          <p class="text-sm text-gray-600">Descripción</p>
          <p class="mt-1">{{ template.description }}</p>
        </div>
        
        <div class="mt-4 text-sm text-gray-500">
          <p>Creado por: {{ template.creator?.name || 'Sistema' }}</p>
          <p>Fecha de creación: {{ formatDatetime(template.created_at) }}</p>
        </div>
      </div>

      <div class="mt-8">
        <h2 class="font-semibold text-lg mb-4">Comidas y Porciones</h2>
        
        <div v-for="meal in template.meals" :key="meal.id" class="card mb-4">
          <div class="flex justify-between items-center mb-3">
            <h3 class="font-medium text-primary-500">Comida {{ meal.meal_number }}</h3>
            <span class="text-sm text-gray-600">
              Total: {{ getMealTotal(meal) }}%
            </span>
          </div>
          
          <div v-if="meal.comments" class="mb-3 p-2 bg-blue-50 rounded text-sm">
            <p class="font-medium text-blue-800">Comentarios:</p>
            <p class="text-blue-700">{{ meal.comments }}</p>
          </div>
          
          <div class="space-y-2">
            <div
              v-for="portion in meal.portions"
              :key="portion.id"
              class="flex justify-between items-center p-2 bg-gray-50 rounded"
            >
              <div>
                <p class="font-medium">{{ portion.name }}</p>
                <p class="text-sm text-gray-600">
                  {{ portion.category }} - {{ portion.subcategory }}
                </p>
              </div>
              <p class="font-medium">{{ portion.percentage }}%</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import LoaderIcon from "@/icons/LoaderIcon";
import { formatDate, formatDatetime } from "@/utils/dateFormatter";
import { mapState } from "vuex";
import api from "@/api";

export default {
  name: "DietTemplatesDetail",

  components: {
    LoaderIcon
  },

  data() {
    return {
      template: null,
      loading: false
    };
  },

  computed: {
    ...mapState({
      user: "user"
    })
  },

  mounted() {
    this.$store.commit("setSelectedTab", "dietTemplates");
    this.loadTemplate();
  },

  methods: {
    formatDate,
    formatDatetime,

    hasPermission(permission) {
      return this.user?.permissions?.includes(permission) || false;
    },

    getTemplateTypeLabel(type) {
      const labels = {
        transition: "Transición",
        standard: "Estándar",
        special: "Especial"
      };
      return labels[type] || type;
    },

    getMealTotal(meal) {
      return meal.portions.reduce((sum, portion) => sum + parseFloat(portion.percentage), 0).toFixed(0);
    },


    async loadTemplate() {
      this.loading = true;
      try {
        console.log("Loading template with ID:", this.$route.params.id);
        const response = await api.dietTemplates.getById(this.$route.params.id);
        console.log("Template response:", response);
        this.template = response;
        this.$store.commit('setBreadcrumbLabel', {
          routeName: 'dietTemplatesDetail',
          label: this.template.name,
        });
      } catch (error) {
        console.error("Error loading template:", error);
        this.$store.commit("setSnack", {
          message: "Error al cargar la plantilla",
          color: "error"
        });
        this.$router.push({ name: "dietTemplatesIndex" });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>